<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerCurrentList' }">合作往来</el-breadcrumb-item>
                <el-breadcrumb-item>合作往来{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit } from '@/js/common.js';

export default {
    name: 'partnerCurrentEdit',
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.initFormData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                partner_rid: { request_uri: 'dropdownPartners', title: '合作方', ref: 'partner_rid_ref', type: 'dropdown' },
                product_rid: { request_uri: 'dropdownProducts', title: '产品', ref: 'product_rid_ref', type: 'dropdown' ,request_params: { type_code: [11, 91] }},
                period: { request_uri: 'monthPeriods', title: '月', ref: 'period_ref', type: 'dropdown', select_value: 'value' },
                type: {
                    request_uri: 'partnerCurrentType',
                    title: '类型',
                    ref: 'type_ref',
                    type: 'dropdown',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                period: [{ required: true, message: '请选择期间', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                partner_rid: this.data.partner_rid || '',
                product_rid: this.data.product_rid || '',
                period: this.data.period || '',
                type: this.data.type || ''
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('dataList')).partner_current;

            processColDataToEdit(
                temp,
                this,
                {
                    black: ['created_at', 'updated_at', 'rid', 'partner_name', 'product_code', 'product_name']
                },
                {
                    type_label: 'type'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/partnerCurrentList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .partnerCurrentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'partnerCurrentUpdate';
            } else {
                uri = 'partnerCurrentInsert';
            }

            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>